module.exports = __webpack_public_path__ + "img/userLogo8.b8b3643e.jpg";